export default __webpack_public_path__ + "static/media/photo--lg--kara13.5225ee4b.jpg";